orders-planner-line-ui-schedules-right
  span.left-btn(onClick="{onClickLeft}" onMouseDown="{onDown}")
    span.feather.icon-arrow-left
  span.right-btn(onClick="{onClickRight}" onMouseDown="{onDown}")
    span.feather.icon-arrow-right
  span.base-line(onMouseDown="{onDown}")
  script(type="typescript").
    this.mixin('orders.planner.line-ui.schedules-right');
